import type { RestaurantId } from '~/lib/graphql/scalars'
import { Link } from '~/navigation/Link'
import { css } from '~/styled-system/css'

export const PpgOnlyPolicies = import.meta.env.VITE_MODE === 'ppg' ? Policies : Empty

function Policies({ restaurantId }: { restaurantId: RestaurantId }) {
  return (
    <Link
      to={`/${restaurantId}/policies`}
      target="_blank" // 予約フローの中断を避けつつポリシーを参照できるように別タブで開く
      className={css({ color: 'link', fontSize: 'sm', fontWeight: 'bold' })}
    >
      このお店のプライバシーポリシー・特定商取引法について
    </Link>
  )
}

function Empty() {
  return null
}
